// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_3co","cls2":"LoswpTabsHero-cls2_Yrh LoswpTabsHero-cls1_3co"};